import { callGuestAPI } from "../axios/guestAxios";

async function getAllPackages() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-all-packages",
  };
  const res = await callGuestAPI(options);
  return res;
}

const PackageServices = {
  getAllPackages,
};

export default PackageServices;
